export default __webpack_public_path__ + "static/images/app-phone-2x-726ad0baa542a0cbfc4f9408b8a24a37.png";